import React from 'react';
import { Switch } from 'react-router-dom';
import { componentService } from 'js/services/component.service';

export const PageRoute = React.lazy(() => import(/* webpackChunkName: "page-route" */ './PageRoute'));

componentService.registerWebContentComponents({
    PageRoute,
    PageRouteSwitch: Switch
});
